<template>
  <div class="container fill-height">
    <v-row align="center" justify="center" align-content="center">
      <v-col>
        <div class="d-flex justify-center mb-5">
          <v-img
            v-if="this.status_code === '201'"
            src="../assets/illustration/waiting-payment.svg"
            max-width="280"
            class="mb-5"
          ></v-img>
          <v-img
            v-else
            src="../assets/illustration/success-payment.svg"
            max-width="280"
            class="mb-5"
          ></v-img>
        </div>
        <h2 class="mb-2 text-center">{{ title }}</h2>
        <p class="text-center">{{ message }}</p>
        <v-row>
          <v-col
            ><v-btn color="default" block :to="{ name: 'Explore' }"
              >Explore Event</v-btn
            ></v-col
          >
          <v-col v-if="this.order_id"
            ><v-btn
              color="primary"
              block
              :to="{
                name: 'MyTicketDetail',
                params: { transaction_id: this.getOrderId(this.order_id) },
              }"
              >Lihat Tiket Saya</v-btn
            ></v-col
          >
          <v-col v-else
            ><v-btn
              color="primary"
              block
              :to="{
                name: 'MyTicket',
              }"
              >Lihat Tiket Saya</v-btn
            ></v-col
          >
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CheckoutSuccess',
  data() {
    return {
      order_id: this.$route.query.order_id,
      status_code: this.$route.query.status_code,
      title: 'Yeay, pemesanan berhasil',
      message:
        'Terima kasih telah memesan di Eventversity, e-tiket kamu telah terbit',
    };
  },

  created() {
    console.log(this.status_code);
    if (this.status_code === '201') {
      this.title = 'Menunggu pembayaranmu';
      this.message =
        'Terima kasih telah memesan di Eventversity, segera lakukan pembayaran untuk mendapatkan tiket kamu';
    } else if (this.status_code === '202') {
      this.title = 'Wah, transaksi ditolak';
      this.message =
        'Mohon maaf, pembayaran ditolak oleh penyedia pembayaran atau terdeteksi kecurangan oleh sistem';
    }
  },

  methods: {
    getOrderId(param) {
      return param;
    },
  },
};
</script>

<style scoped></style>
